import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["option", "input"];
  static values = { selected: String };

  connect() {
    this.valuationController = this.application.getControllerForElementAndIdentifier(
      document.querySelector('[data-controller~="valuation"]'),
      'valuation',
    );

    if (this.valuationController) {
      this.conflictStatusTarget = this.pickVisibleTarget(this.valuationController.conflictStatusTargets)
      this.conflictStatusNotesTarget = this.pickVisibleTarget(this.valuationController.conflictStatusNotesTargets)
      this.displayConflictStatusNotesTarget = this.pickVisibleTarget(this.valuationController.displayConflictStatusNotesTargets)

      const def = this.conflictStatusTarget?.value;
      if (def) this.selectByValue(def);

      this.syncNotesFieldsFromMainForm()
    }
  }

  handleSubmit(event) {
    // If valuation form exists on the page (Edit page), defer save to main form
    // Otherwise (Overview page), allow form to submit to server
    if (this.valuationController) {
      event.preventDefault()
      event.stopImmediatePropagation()

      const conflictStatus = this.inputTarget.value
      if (this.conflictStatusTarget) this.conflictStatusTarget.value = conflictStatus

      const displayCheckbox = this.displayCheckbox()
      const displayChecked = displayCheckbox ? displayCheckbox.checked : true

      if (this.displayConflictStatusNotesTarget) {
        this.displayConflictStatusNotesTarget.value = displayChecked ? 'true' : 'false'
      }

      const notesInput = this.notesInput()
      if (this.conflictStatusNotesTarget) {
        this.conflictStatusNotesTarget.value = displayChecked && notesInput ? notesInput.value : ''
      }
    }
  }

  pickVisibleTarget(targets) {
    if (!targets) return null
    return targets.find(target => {
      const section = target.closest('[data-multi-property-target="reportSection"]')
      return !section || !section.classList.contains('hidden')
    })
  }

  notesInput() {
    return this.element.querySelector('textarea[name$="[conflict_status_notes]"]')
  }

  displayCheckbox() {
    return this.element.querySelector('input[type="checkbox"][name$="[display_conflict_status_notes]"]')
  }

  syncNotesFieldsFromMainForm() {
    const notesInput = this.notesInput()
    if (notesInput && this.conflictStatusNotesTarget) {
      notesInput.value = this.conflictStatusNotesTarget.value
    }

    const displayCheckbox = this.displayCheckbox()
    if (displayCheckbox && this.displayConflictStatusNotesTarget) {
      const value = this.displayConflictStatusNotesTarget.value
      displayCheckbox.checked = value === 'true' || value === '1'
      displayCheckbox.dispatchEvent(new Event('change', { bubbles: true }))
    }
  }

  select(event) {
    event.preventDefault();
    const el = event.currentTarget;
    this.selectByValue(el.dataset.value);
  }

  selectByValue(value) {
    this.optionTargets.forEach((btn) => {
      const isSelected = btn.dataset.value === value;
      btn.classList.toggle("border-brand-1000", isSelected);
      btn.classList.toggle("border-black-100", !isSelected);
      btn.setAttribute("aria-pressed", isSelected ? "true" : "false");
    });

    if (this.hasInputTarget) this.inputTarget.value = value;
    this.selectedValue = value;
  }
}
